module.exports = __webpack_public_path__ + "static/neo-logo-0d272f04f9861e4d9fb5bd34cb31ce5c.jpg";